import { render, staticRenderFns } from "./trainingJudge.vue?vue&type=template&id=b38c510a&scoped=true&"
import script from "./trainingJudge.vue?vue&type=script&lang=js&"
export * from "./trainingJudge.vue?vue&type=script&lang=js&"
import style0 from "./trainingJudge.vue?vue&type=style&index=0&id=b38c510a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38c510a",
  null
  
)

export default component.exports